// Pricing data with no React import, so a server component can read it without
// evaluating the plans table and its createContext call.

export const planResolutions = {
	Starter: { included: 25, pricePerResolution: 0.79 },
	Pro: { included: 50, pricePerResolution: 0.79 },
	Scale: { included: 100, pricePerResolution: 0.79 },
} as const

// Included monthly AI credits per plan, in dollars. Mirrors
// FreeAiTokenSpendCents in @productlane/lib; keep in sync.
export const planAiCredits = {
	Starter: 5,
	Pro: 10,
	Scale: 20,
} as const
